import * as React from 'react';
import { Link } from 'react-router-dom';
import WetnotesLogo from './WetnotesLogo';

export interface BreadCrumb {
    caption: string;
    to: string;
}

export interface ITitleProps {
    baseUrl?: string;
    breadcrumbs?: Array<BreadCrumb>;
    heading?: string;
}

export class Title extends React.Component<ITitleProps> {
    public render() {
        const { heading } = this.props;

        return (
            <div className="title">
                <div className="wrapper">
                    <div className="title__holder">
                        <div className="title__holder__main">
                            <WetnotesLogo title={heading} color="white" />
                        </div>

                        <div className="title__holder__sub">
                            {this.props.breadcrumbs != undefined && (
                                <div>
                                    <span>
                                        <Link to="/app">WetNotes</Link>
                                    </span>
                                    {this.props.breadcrumbs.map(
                                        (item, index) => {
                                            if (item.to) {
                                                return (
                                                    <span key={index}>
                                                        <Link to={item.to}>
                                                            {item.caption}
                                                        </Link>
                                                    </span>
                                                );
                                            }

                                            if (item.caption) {
                                                return (
                                                    <span key={index}>
                                                        {item.caption}
                                                    </span>
                                                );
                                            }
                                            return (
                                                <span key={index}>{item}</span>
                                            );
                                        }
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Title;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Title.tsx